import { render, staticRenderFns } from "./DispatchingResults.vue?vue&type=template&id=08acfd7f&scoped=true"
import script from "./DispatchingResults.vue?vue&type=script&lang=js"
export * from "./DispatchingResults.vue?vue&type=script&lang=js"
import style0 from "./DispatchingResults.vue?vue&type=style&index=0&id=08acfd7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acfd7f",
  null
  
)

export default component.exports